<rcl-language-modal
	[show]="showLanguageSelector"
	(onClose)="closeModal()"
	(onLanguageClick)="selectlanguage($event)"
	[id]="'langSelector'"
	[languages]="languageList"
	[attr.aria-hidden]="!showLanguageSelector"
	[attr.tabindex]="showLanguageSelector ? '0' : '-1'"
>
	<span title>{{ bundle() && bundle()['label.language.selector'] }}</span>
	<span button>{{ bundle() && bundle()['button.close'] }}</span>
</rcl-language-modal>
